// extracted by mini-css-extract-plugin
module.exports = {"expired":"SubscriptionComponent_expired__Bywqh"};